import { STAGES } from './studioData';

export default function StageStepper({ stage }: { stage: number }) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg px-4 md:px-5 py-4">
      <p className="font-label uppercase tracking-widest text-[11px] text-foreground-500 mb-3">Publishing workflow</p>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-3">
        {STAGES.map((label, i) => {
          const done = i < stage;
          const current = i === stage;
          const chipClass = current
            ? 'bg-primary-500 border-primary-500 text-background-50'
            : done
              ? 'bg-primary-100 border-primary-200 text-primary-700'
              : 'bg-background-100 border-background-200 text-foreground-500';
          return (
            <div key={label} className="flex items-center gap-2">
              <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border font-label uppercase tracking-wide text-[10px] font-semibold whitespace-nowrap ${chipClass}`}>
                <span className="w-4 h-4 flex items-center justify-center">
                  {done ? <i className="ri-check-line"></i> : <i className={current ? 'ri-record-circle-line' : 'ri-circle-line'}></i>}
                </span>
                {label}
              </span>
              {i < STAGES.length - 1 && (
                <span className="hidden sm:flex w-4 items-center justify-center text-foreground-300"><i className="ri-arrow-right-line"></i></span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}